import HttpClient from './core/httpClient';
import withAuthApi from './domains/authApi';
import withCatalogApi from './domains/catalogApi';
import withAssignmentsApi from './domains/assignmentsApi';
import withUploadsApi from './domains/uploadsApi';
import withEngagementApi from './domains/engagementApi';
import withAdminApi from './domains/adminApi';
import withAttendanceApi from './domains/attendanceApi';
import withCourseContentApi from './domains/courseContentApi';
import withRecordingUploadApi from './domains/recordingUploadApi';
import withPaymentsApi from './domains/paymentsApi';
import withPollsApi from './domains/pollsApi';
import withRubricsApi from './domains/rubricsApi';
import withExternalItemsApi from './domains/externalItemsApi';

// ApiService — the singleton HTTP API client.
//
// Composition: domain endpoint methods live in ./domains/* as subclass-factory
// mixins ((Base) => class extends Base { ...methods }). They are layered over the
// core ./core/httpClient (request/CSRF/retry/adaptive-timeout) to form one class.
// `this` binds to the ApiService instance in every method, so this.request() and
// cross-domain calls resolve through the shared prototype chain.
const ApiServiceBase = [
  withAuthApi,
  withCatalogApi,
  withAssignmentsApi,
  withUploadsApi,
  withEngagementApi,
  withAdminApi,
  withAttendanceApi,
  withCourseContentApi,
  withRecordingUploadApi,
  withPaymentsApi,
  withPollsApi,
  withRubricsApi,
  withExternalItemsApi,
].reduce((Base, mixin) => mixin(Base), HttpClient);

class ApiService extends ApiServiceBase {}

// Create and export a singleton instance
const apiService = new ApiService();
export default apiService;
